import UpdatePlantingCycleContainer from './UpdatePlantingCycleContainer';

export default UpdatePlantingCycleContainer;
